/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { HomeService } from '../../components/home/home.service';
import { UtilitiesPanelService } from '../../shared/services/utilitiesPanel.service';
import { HomeSearchFilterPipe } from '../../shared/pipes/HomeSearchFilterPipe';
import { DomSanitizer } from '@angular/platform-browser';
import { SaveNdShareReportModalComponent } from '../../shared/save-modal/save-modal.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-utilities-panel',
    templateUrl: './utilities-panel.component.html',
    styleUrls: ['./utilities-panel.component.scss'],
    providers: [HomeSearchFilterPipe]
})

export class UtilitiesPanelComponent implements OnInit, OnChanges {
    @Output() closeSlider: EventEmitter<any> = new EventEmitter();
    @Input() receivedCard: any;
    @Input() tabType = 'userhomePage'; 
    public card: any = {};
    private homeMetaData: any;
    public sort: any = {
        'recently': true,
        'bookmark': true
    };
    public cardClick: any = '';
    public cardsList: any;
    public noDataAvailable = true;
    public updatingItem: any;
    public hasViewAccess = true;
    public hasUpdateAccess = true;
    public fadeViewIcon = true;
    private defaultConfig: ModalOptions = {
        backdrop: true,
        ignoreBackdropClick: true
    };    

    constructor(
        private router: Router,
        public commonService: CommonService,
        private utilitiesPanelService: UtilitiesPanelService,
        private toastr: ToastrService,
        private homeService: HomeService,
        public sanitizer: DomSanitizer,
        private modalService: BsModalService) {
    }

    ngOnInit() {
        this.card = this.receivedCard;
        this.hasViewAccess = this.commonService.hasFeatureAccess('User Activity View');
        this.hasUpdateAccess = this.commonService.hasFeatureAccess('User Activity Update'); 
        // VCE-4567: clearing action type       
        localStorage.removeItem('PlannedManagerActionType');
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['receivedShareUtilitySuccess'] && changes['receivedShareUtilitySuccess'].currentValue) {
            this.getHomeRecentDetails(null);
        }

        if (changes['receivedCard'] && changes['receivedCard'].currentValue && this.hasViewAccess) {
            this.homeMetaData = this.commonService.getHomeMetaDetails();
            this.getHomeRecentDetails(null);
        }
    }

    public getTranslationWithKey(key: string): string {
        return this.commonService.getTranslatedVal(key);
     }

    public sortBy(card: any){
        card.recentSort = !card.recentSort;
        if(card.recentSort){
            this.getHomeRecentDetails(card);
        }else{
            this.getHomeDetails(card);
        }
    }

    public onMouseOver(e: any, card: any) {
        let className: any;
        if (card.code == 'RVC') {
            className = '.BSC' + 'cardContainer';
        } else {
            className = '.RVC' + 'cardContainer';
        }
        if (document.querySelector(className)) {
            document.querySelector(className).classList.add('cald_pointer-events');
        }
    }

    public onMouseOut(e: any, card: any) {
        let className: any;
        if (card.code == 'RVC') {
            className = '.BSC' + 'cardContainer';
        } else {
            className = '.RVC' + 'cardContainer';
        }
        if (document.querySelector(className)) {
            document.querySelector(className).classList.remove('cald_pointer-events');
        }
    }

    private getHomeRecentDetails(card: any) {
        // card ? card.recentSort = true : '';
        if (card) {
            card.recentSort = true;
        }
        this.commonService.getBookmarksTabType(this.tabType)
            .then(this.getHomeDetailsSH.bind(this), (reason) =>this.commonService.commonErrorHandler(reason));
    }

    public getHomeDetails(card: any) {
        if (card) {
            card.recentSort = false;
        }
        this.homeService.getHomeDetails()
            .then(this.getHomeDetailsSH.bind(this), (reason) =>this.commonService.commonErrorHandler(reason));
    }

    public getCardClasses(card: any) {
        const clsStr: any = [];
        clsStr.push(card.code + 'cardContainer');
        if (card.showCloseIcon) {
            clsStr.push('cc_slider-body-content');
        } else {
            clsStr.push('sponsor-home-container');
        }
        return clsStr;
    }

    private getHomeDetailsSH(response: any) {
        const responseMsg = response;
        if (responseMsg) {
            this.card = this.receivedCard;
            if (this.card) {
                this.bindModuletoCards();
                if (this.card.code == 'RVC') {
                    this.bindListItemsToCards(responseMsg.data.lastAccessReports);
                } else if (this.card.code == 'BSC') {
                    this.bindListItemsToCards(responseMsg.data.bookmarks);
                }
            }
        }
    }

    private bindListItemsToCards(data: any) {
        const vm = this;
        this.card.items.forEach(function (cardItem: any) {
            cardItem.list = [];
            data.forEach(function (dataItem: any) {
                if (((cardItem.id == dataItem.moduleId) && !dataItem.sharedFrom) || (!cardItem.id && dataItem.sharedFrom)) {
                    dataItem.icon = vm.getModuleImage(dataItem);
                    cardItem.list.push(dataItem);
                }
            });
        });
        this.noDataAvailable = this.checkIsDataAvailable();
    }

    private checkIsDataAvailable() {
        let noDataFlag = true;
        this.card.items.forEach(function (cardItem: any) {
            if (cardItem.list.length) {
                noDataFlag = false;
                return noDataFlag;
            }
        });
        return noDataFlag;
    }

    private getModuleImage(moduleItem: any) {
        let userImg = '';
        switch (moduleItem.moduleId) {
            case 1:
                userImg = 'icon-person-placeholder';
                break;
            case 2:
                userImg = 'icon-tree';
                break;
            case 3:
                userImg = 'icon-expense-report';
                break;
            default:
                userImg = 'icon-sales-quote';
        }
        return userImg;
    }

    private bindModuletoCards() {
        const vm = this;
        if (this.card.items) {
            this.card.items.forEach(function (cardItem: any) {
                if (vm.homeMetaData) {
                    for (const mod of vm.homeMetaData.modules) {
                        if (mod.code == cardItem.code) {
                            cardItem.id = mod.id;
                        }
                    }
                }
            });
        }

    }

    public navigateItem(item: any) {
        if (item.sharedFrom && !item.shareViewed) {
            /* Updating shareViewed flag to true, once user clicks on shared bookmark */
            const payload = {
                'name': item.name,
                'clientID': item.clientID,
                'moduleId': item.moduleId,
                'shareViewed': true
            };
            this.utilitiesPanelService.updateUtilityItem(this.card.code, item.id, payload)
                .then(this.updateSharedViewSH.bind(this, item), (reason) =>this.commonService.commonErrorHandler(reason));
        } else {
            this.redirectItem(item);
        }
    }

    private updateSharedViewSH(item: any, response: any) {
        item.shareViewed = true;
        this.redirectItem(item);
    }

    private redirectItem(item: any) {
        switch (item.moduleId) {
            case 1:
                this.router.navigateByUrl('/fieldsupport/distributorDetails/' + item.clientID);
                break;
            case 2:
                if (item.clientID) {
                    localStorage.setItem('genealogyParticipantId', item.clientID);
                    localStorage.setItem('genealogyGroup', item.groupId);
                }
                // Fix to show report template as it was while saving bookmark
                if(item.reportId) {
                    this.router.navigateByUrl('/genealogyHome/genealogy/' + item.reportId);
                }else {
                    this.router.navigateByUrl('/genealogyHome/genealogy/default');
                }
                break;
            case 3:
                this.router.navigateByUrl(this.getSourcePath(item));
                break;
            default:
                this.router.navigateByUrl('/fieldsupport/distributorDetails/' + item.clientID);
        }
    }

    private getSourcePath(item: any) {
        let path: any = '';
        switch (item.source) {
            case 'Genealogy':
                path = '/genealogyHome/genealogy/';
                if (item.clientID) {
                    localStorage.setItem('genealogyParticipantId', item.clientID);
                    localStorage.setItem('genealogyGroup', '');
                }
                break;
            case 'GenealogyReports':
                if (item.clientID) {
                    localStorage.setItem('genealogyParticipantId', item.clientID);
                    localStorage.setItem('genealogyGroup', '');
                }
                path = '/genealogyHome/genealogy/';
                break;
            case 'CompensationReports':
                path = '/compensationHome/compensationAnalytics/';
                break;
            case 'IncentiveReports':
                path = '/compensationHome/incentives/';
                break;
            case 'TieredCompensationsReports':
                path = '/compensationHome/tieredCompensations/';
                break;
            case 'PaymentReports':
                path = '/compensationHome/payments/';
                break;
            case 'MiscReport':
                path = '/genealogyHome/miscReport/';
                break;
            case 'DistributorSupportReports':
                if (item.clientID) {
                    localStorage.setItem('clientIdFromHomePage', item.clientID);
                }
                path = '/fieldsupport/distributorList/';
                break;
            case 'Order':
                if (item.clientID) {
                    localStorage.setItem('ordersParticipantId', item.clientID);
                }
                path = '/fieldsupport/participantOrders/';
                break;
            default:
                path = '/compensationHome/compensationAnalytics/';
        }
        return path + item.reportId;
    }

    public close() {
        this.closeSlider.emit();
    }

    public toggleActionIconSearch(evt: any, card: any) {
        evt.stopPropagation();
        card.showSearchBox = !card.showSearchBox;
    }

    public clearFilter(evt: any, card: any, type: any) {
        evt.stopPropagation();
        card.filterVal = '';
        (type == 'toggleSearch') ? card.showSearchBox = !card.showSearchBox : '';
    }

    public displayList(item: any, state: any) {
        item.collapse = !state;
    }

    public editListItem(event: any, listItem: any) {
        event.stopPropagation();
        listItem.updatedName = listItem.name;
        listItem.editable = true;
    }

    public cancelEdit(listItem: any) {
        listItem.editable = false;
    }

    public updateName(listItem: any) {
        const payload = {
            'name': listItem.updatedName,
            'clientID': listItem.clientID,
            'moduleId': listItem.moduleId
        };
        this.utilitiesPanelService.updateUtilityItem(this.card?.code, listItem.id, payload)
            .then(this.updateNameSH.bind(this, listItem), (reason) =>this.commonService.commonErrorHandler(reason));
    }

    private updateNameSH(listItem: any, response: any) {
        listItem.editable = false;
        listItem.name = listItem.updatedName;
        this.toastr.success(this.getTranslationWithKey('operation_success'), this.getTranslationWithKey('success'));
    }

    public deleteListItem(event: any, listItem: any) {
        event.stopPropagation();
        this.utilitiesPanelService.deleteUtilityItem(this.card.code, listItem.id)
            .then(this.deleteUtilityItemSH.bind(this, listItem), (reason) =>this.commonService.commonErrorHandler(reason));
    }

    private deleteUtilityItemSH(listItem: any, response: any) {
        listItem.deleted = true;
        this.toastr.success(this.getTranslationWithKey('operation_success'), this.getTranslationWithKey('success'));
    }

    public undoRemove(listItem: any) {
        const payload = this.createPayload(listItem);
        delete payload.id;
        this.utilitiesPanelService.createUtilityItem(this.card.code, payload)
            .then(this.undoRemoveSH.bind(this, listItem), (reason) =>this.commonService.commonErrorHandler(reason));
    }

    private undoRemoveSH(listItem: any, response: any) {
        const restoredItem = this.getRestoredItem(response.data || [], listItem.name);
        listItem.deleted = false;
        listItem.id = restoredItem.id;
        this.toastr.success(this.getTranslationWithKey('operation_success'), this.getTranslationWithKey('success'));
    }

    private getRestoredItem(response: any, listName: any){
        const listItem = response.find(function(item: any){
            return item.name == listName;
        });
        return listItem;
    }

    private createPayload(listItem: any) {
        const payload = JSON.parse(JSON.stringify(listItem));
        delete payload.updatedName;
        delete payload.editable;
        delete payload.icon;
        delete payload.deleted;

        return payload;
    }

    public shareUtility(event: any, listItem: any) {
        event.stopPropagation();
        const utility = JSON.parse(JSON.stringify(listItem));
        const initialState = {
            viewDtls: utility,
            fromDtls: { name: this.card?.name, from: "utility" }
          };
          const modalRef: BsModalRef = this.modalService.show(SaveNdShareReportModalComponent, {
            ...this.defaultConfig,
            initialState,
            class: 'modal-dialog modal-custom-width'
          });
          // Handle modal close event
          modalRef.content?.closeModal?.subscribe((result: any) => {
            if (result) {
              this.saveWindowClosed(result);
            }
          });
          // Handle modal dismissal
          modalRef.onHide?.subscribe((err: any) => {
            this.saveWindowClosed(err);
          });
    }

    private saveWindowClosed(payload: any) {
        if (payload.saved) {
            const request = {
            name: payload.nameOfReport,
            id: payload.idOfTheReport,
            whomToShare: this.prepareWhomToShare(payload.selectedUserIds || [])
            };
            this.utilitiesPanelService.shareUtility(this.card.code, request)
                .then(this.shareUtilitySH.bind(this), (reason) =>this.commonService.commonErrorHandler(reason));
        }
    }

    private prepareWhomToShare(items: any) {
        const response = [];
        if (items && items.length) {
          for (const item of items) {
            response.push({
              emailId: item
            });
          }
        }
        return response;
    }

    private shareUtilitySH(response: any) {
        setTimeout(() => {
            this.toastr.success(this.getTranslationWithKey("operation_success"), this.getTranslationWithKey("success"));
        }, 300);
    }
    
    // Handle reorder and persist the new order
    public onCardItemsReorder(event: any, card: any): void {
        // Reassign order numbers
        card.items = card.items.map((item: any, index: number) => {
            item.displayOrder = index + 1;
            item.isOrderChanged = true;
            return item;
        });
    }

}